import './DraftActions.css';

const DraftActions = ({
  canUndo,
  canRedo,
  canAutoDraft,
  canFullAutoDraft,
  isFullAutoDrafting,
  onUndo,
  onRedo,
  onAutoDraft,
  onFullAutoDraft,
  onShowPlayers
}) => {
  return (
    <div className="draft-actions">
      <button
        className="undo-button"
        onClick={onUndo}
        disabled={!canUndo}
      >
        ↩ Undo
      </button>
      <button
        className="auto-draft-button"
        onClick={onAutoDraft}
        disabled={!canAutoDraft}
      >
        Auto Draft
      </button>
      <button
        className="full-auto-draft-button"
        onClick={onFullAutoDraft}
        disabled={!canFullAutoDraft}
      >
        {isFullAutoDrafting ? 'Stop AutoDraft' : 'Full AutoDraft'}
      </button>
      <button
        className="redo-button"
        onClick={onRedo}
        disabled={!canRedo}
      >
        Redo ↪
      </button>
      <button
        className="show-players-button"
        onClick={onShowPlayers}
      >
        Players
      </button>
    </div>
  );
};

export default DraftActions;
